import { formatPrice } from '../../dynamicBundle/index.js';
import { setSessionStorage, handleClickTagAItemBuildUrlWithLocale } from '../../utils';
import {
  VOLUME_RADIO_LABEL_SELECTOR,
  VOLUME_MENU_SELECTOR,
  VOLUME_MENU_ITEM_SELECTOR,
  VOLUME_RADIO_SELECTOR,
  VOLUME_RADIO_CHECKED,
  KEY_VOLUME_BUNDLE_RADIO,
  RECOMMENDATION_SELECTOR,
  KEY_VOLUME_BUNDLE,
  DROPDOWN_SELECT_OPTION,
} from '../constants';
import { closeAllDropdown, toggleDropdown, selectVariantProduct } from './dropdown-events';
import { closeVolumeBundleModal } from './modal-events';

/**
 * @type {import('../index.d').toggleRadio}
 */
const toggleRadio = async (context, target, wrapper) => {
  const label = target.closest(VOLUME_RADIO_LABEL_SELECTOR);
  if (!label) return;

  const menu = label.closest(VOLUME_MENU_SELECTOR);
  if (!menu) return;

  const menuItem = label.closest(VOLUME_MENU_ITEM_SELECTOR);
  if (!menuItem) return;

  const radioInput = menuItem.querySelector(VOLUME_RADIO_SELECTOR);
  if (!radioInput) return;

  menu.querySelectorAll(VOLUME_RADIO_SELECTOR).forEach((radio) => {
    radio.classList.remove(VOLUME_RADIO_CHECKED);
    radio.checked = false;
  });

  radioInput.classList.add(VOLUME_RADIO_CHECKED);
  radioInput.checked = true;

  const selectedRadioId = radioInput.getAttribute('id');
  setSessionStorage(KEY_VOLUME_BUNDLE_RADIO, selectedRadioId);

  const widgetId = target.closest(RECOMMENDATION_SELECTOR)?.dataset?.widgetId;
  const [getVolumeBundleData, setVolumeBundleData] = context.useContextState(
    `${KEY_VOLUME_BUNDLE}-${widgetId}`,
    {}
  );
  const bundleData = getVolumeBundleData();

  if (!bundleData) {
    console.error('Không tìm thấy dữ liệu bundle');
    return;
  }

  bundleData.bundleOptions = bundleData.bundleOptions.map((option) => {
    const selectedVariant =
      bundleData.matchedProduct.variants.find(
        (variant) => variant.id === Number(option.selectedDropdownOptions?.variantId)
      ) || bundleData.matchedProduct.variants[0];

    const originPrice = selectedVariant.price;
    const currencyRate = Number(window.Shopify?.currency?.rate || 1);
    const discount = bundleData.discounts.find((d) => d.item === option.items) || {};
    const discountedPrice =
      discount.discount_type === 'percentage'
        ? originPrice * discount.item -
          (originPrice * discount.item * discount.discount_value) / 100
        : Math.max(0, originPrice * discount.item - discount.discount_value * currencyRate);

    return {
      ...option,
      checked: option.id === selectedRadioId,
      selectedDropdownOptions: {
        ...option.selectedDropdownOptions,
        variantId: selectedVariant.id,
        title: selectedVariant.title,
        image: selectedVariant.image || bundleData.matchedProduct.images_info?.[0]?.src,
        discountedPrice: formatPrice(context, discountedPrice),
        originalPrice: formatPrice(context, originPrice * discount.item),
        rawDiscountedPrice: discountedPrice,
      },
    };
  });

  bundleData.selectedOption = bundleData.bundleOptions.find((option) => option.checked);
  setVolumeBundleData(bundleData);
};

/**
 * @type {import('../index.d').initBasicEventsForVolumeBundle}
 */
export const initBasicEventsForVolumeBundle = (context, target, event, wrapper, position) => {
  toggleRadio(context, target, wrapper);

  selectVariantProduct(context, target, wrapper, position);
  if (target?.closest(`.${DROPDOWN_SELECT_OPTION}`)) {
    toggleDropdown(target);
  } else {
    closeAllDropdown();
  }

  if (
    (!target?.closest(RECOMMENDATION_SELECTOR) &&
      !target?.closest('.boost-sd__volume-bundle-product-item')) ||
    target?.closest('.boost-sd__volume-bundle-modal-close')
  ) {
    closeVolumeBundleModal(context);
  }

  const classProductLink =
    'a.boost-sd__volume-bundle-product-link, a.boost-sd__volume-bundle-link-image';
  handleClickTagAItemBuildUrlWithLocale(event, classProductLink);
};
